import { ChangeDetectionStrategy, Component, OnDestroy, inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { Subject, takeUntil } from 'rxjs';
import { ADDRESS, EMAIL, PHONE_NUMBER } from '../../_shared/_constants/contact-info';
import { EmailService } from '../../_shared/_services/email.service';
import { GoogleAnalyticsService } from '../../_shared/_services/google-analytics.service';
import { Router, RouterLink } from '@angular/router';
import { ContactUsFormComponent } from '../../_shared/_components/contact-us-form/contact-us-form.component';
import { MatFormField, MatError } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ContactUsFormComponent, RouterLink, FormsModule, ReactiveFormsModule, MatFormField, MatInput, MatError, FaIconComponent]
})
export class FooterComponent implements OnDestroy {
  private readonly formBuilder = inject(UntypedFormBuilder);
  private readonly reCaptchaV3Service = inject(ReCaptchaV3Service);
  private readonly emailService = inject(EmailService);
  private readonly googleAnalyticsService = inject(GoogleAnalyticsService);
  private readonly router = inject(Router);

  public newsletterForm: UntypedFormGroup;
  public email = new UntypedFormControl('', [Validators.required, Validators.email]);
  public year = new Date().getFullYear();
  public isSubmitting = false;
  public phoneNumber = PHONE_NUMBER;
  public address = ADDRESS;
  public ourEmail = EMAIL;

  private readonly unsubscribe: Subject<undefined> = new Subject<undefined>();

  constructor() {
    this.newsletterForm = this.formBuilder.group({
      email: this.email
    });
  }

  public ngOnDestroy(): void {
    this.unsubscribe.next(undefined);
    this.unsubscribe.complete();
  }

  public getErrorMessage(): string {
    if (this.email.hasError('required')) {
      return 'You must enter a value';
    }

    return this.email.hasError('email') ? 'Not a valid email' : '';
  }

  public submit(): void {
    if (this.newsletterForm.valid) {
      this.googleAnalyticsService.eventEmitter('Footer Newsletter Signup', 'Footer', 'Clicked Sign Up', 'Newsletter Signup', 1);
      this.isSubmitting = true;
      this.reCaptchaV3Service.execute('newsletterSignup')
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(token => {
        this.emailService.signUpForNewsletter(this.email.value, `https://mypoolhut.com${this.router.url}`, token)
          .subscribe(res => {
            if (res) {
              this.emailService.success('Thank you for signing up!')
            } else {
              console.error('Failed to submit.');
            }
            this.isSubmitting = false;
          },
          error => {
            this.isSubmitting = false;
            console.error('Failed to submit.', error);
            this.emailService.error('Failed to submit. Please try again.');
          });
      });
    }
  }

  public callUs(): void {
    this.googleAnalyticsService.eventEmitter('Footer Phone Call', 'Footer', 'Clicked Call Us', 'Phone Call', 1);
  }
}
